import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorModel } from '@spartacus/core';

import { MeasurementSystem } from '../../types/measurement-system.type';

export const MeasurementSystemsActions = createActionGroup({
  source: '[Measurement Systems]',
  events: {
    loadMeasurementSystems: emptyProps(),
    loadMeasurementSystemSuccess: props<{ payload: MeasurementSystem[] }>(),
    loadMeasurementSystemsFail: props<{ payload: HttpErrorModel | Error }>(),
    setActiveMeasurementSystem: props<{ payload: string }>(),
    changeActiveMeasurementSystem: props<{ payload: string }>(),
    changeActiveMeasurementSystemSuccess: props<{ payload: string }>(),
    changeActiveMeasurementSystemFail: props<{ payload: HttpErrorModel | Error }>()
  }
});
